<template>
    <div class="com-item breadcrumb-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky"
                :style="{
                    backgroundColor: W.bgColor || 'transparent',
                    color: W.textColor || '#666'
                }"
            >
                <div class="breadcrumb-module__inner">
                    <template v-for="(it, idx) in W.items">
                        <span :key="'t' + idx" class="breadcrumb-module__item">
                            <a
                                v-if="it.linkUrl"
                                :href="it.linkUrl"
                                target="_self"
                                class="breadcrumb-module__link"
                                @click.stop="onClick($event, it)"
                            >{{ it.text }}</a>
                            <span v-else class="breadcrumb-module__text">{{ it.text }}</span>
                        </span>
                        <i
                            v-if="idx < W.items.length - 1"
                            :key="'s' + idx"
                            class="el-icon-arrow-right breadcrumb-module__sep"
                        ></i>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'breadcrumb-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'breadcrumb',
                    Title: '面包屑导航',
                    MID: 37,
                    ModuleName: 'breadcrumbModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            defaultData: {
                bgColor: '',
                textColor: '#666',
                items: [
                    { text: '首页', linkUrl: '/', linkName: '首页' },
                    { text: '技术实力', linkUrl: '', linkName: '' }
                ]
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.items) || !this.modata.WContent.items.length) {
            this.$set(this.modata.WContent, 'items', JSON.parse(JSON.stringify(this.defaultData.items)))
        }
    },
    methods: {
        onClick(e, item) {
            if (!item.linkUrl) return
            e.preventDefault()
            this.pageNavigate(item.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
.breadcrumb-module {
    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 16px 0;
    }

    .breadcrumb-module__inner {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 16px;
        line-height: 1.4;
    }

    .breadcrumb-module__item {
        display: inline-flex;
        align-items: center;
    }

    .breadcrumb-module__text {
        color: inherit;
    }

    .breadcrumb-module__link {
        color: #333;
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
            color: #e60012;
        }
    }

    .breadcrumb-module__sep {
        margin: 0 8px;
        color: #999;
        font-size: 12px;
        font-style: normal;
    }
}
</style>